import { Link } from "react-router-dom";
import AIAgentCTA from "@/components/AIAgentCTA";

const NAV_COLUMNS = [
  {
    title: "Divisions",
    links: [
      { to: "/growth-system", label: "Growth Systems" },
      { to: "/growth-os", label: "Growth OS (Software)" },
      { to: "/what-we-do#toulios-financial-strategy", label: "Financial Strategy" },
      { to: "/what-we-do#toulios-revenue-&-sales", label: "Revenue & Sales" },
      { to: "/what-we-do#toulios-operations", label: "Operations" },
    ],
  },
  {
    title: "Firm",
    links: [
      { to: "/what-we-do", label: "What We Do" },
      { to: "/pricing", label: "Pricing" },
      { to: "/case-studies", label: "Case Studies" },
      { to: "/about", label: "About" },
      { to: "/contact", label: "Contact" },
    ],
  },
  {
    title: "Legal",
    links: [
      { to: "/trust", label: "Trust & Privacy" },
      { to: "/legal/privacy", label: "Privacy Policy" },
      { to: "/legal/terms", label: "Terms of Use" },
      { to: "/legal/disclosures", label: "Disclosures" },
    ],
  },
];

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#070707] border-t border-white/[0.06] mt-24"
    >
      <div className="container-x py-20 md:py-28">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3">
              <img
                src="/logo-mark.png"
                alt="Toulios Advisory Group"
                data-testid="footer-logo-mark"
                className="w-12 h-12 object-contain"
              />
              <span className="font-display text-lg tracking-tight leading-none">
                Toulios <span className="text-zinc-400">Advisory Group</span>
              </span>
            </div>
            <p className="mt-6 text-zinc-400 max-w-md text-pretty leading-relaxed">
              A senior Australian advisory firm. We help established operators
              grow across financials, sales, operations and systems, and
              install the systems that keep the growth running.
            </p>
            <p className="mt-4 text-zinc-500 text-sm">
              Toulios Advisory Group is a trading name of Toulios Wealth
              Management Pty Ltd, Australia.
            </p>
          </div>

          {NAV_COLUMNS.map((col) => (
            <div key={col.title} className="lg:col-span-2">
              <div className="overline">{col.title}</div>
              <ul className="mt-6 space-y-3">
                {col.links.map((l) => (
                  <li key={l.to}>
                    <Link
                      to={l.to}
                      data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                      className="text-sm text-zinc-300 hover:text-gold transition-colors"
                    >
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="lg:col-span-3">
            <div className="overline">Get in touch</div>
            <p className="mt-6 text-sm text-zinc-300">
              Start with a 5 to 15-minute AI Strategist call. A senior consultant prepares your plan and follows up within 1 to 2 business days.
            </p>
            <div className="mt-6 flex flex-col gap-3">
              <AIAgentCTA testId="footer-cta-ai" label="Talk to AI Strategist" />
              <Link
                to="/contact"
                className="btn-ghost"
                data-testid="footer-cta-book"
              >
                Book a Strategy Call
              </Link>
            </div>
          </div>
        </div>

        <div className="mt-20 pt-10 border-t border-white/[0.06]">
          <p className="text-xs text-zinc-500 leading-relaxed max-w-4xl">
            <strong className="text-zinc-400 font-medium">Important disclosure.</strong>{" "}
            Content on this site is general information only and does not
            constitute financial product advice, a recommendation, or an offer
            of any financial product or service. Toulios Advisory Group is a
            trading name of Toulios Wealth Management Pty Ltd (ACN 667 133 977
            · ABN 68 667 133 977), a management consulting firm (ANZSIC
            M696299). We are not a broker, do not hold an AFSL, and do not
            provide brokerage, financial product advice, or any other
            regulated financial service. You should obtain independent
            professional advice before acting on any information on this site.
          </p>
          <div className="mt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
            <span className="text-xs text-zinc-600">
              © {new Date().getFullYear()} Toulios Wealth Management Pty Ltd, trading as Toulios Advisory Group. All rights reserved.
            </span>
            <span className="text-xs text-zinc-600">ACN 667 133 977 · ABN 68 667 133 977 · Sydney · Australia</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
